import {
    Box,
    Chip
} from "@mui/material";
import React, {
    ReactNode
} from 'react';

import { darken } from "@mui/material/styles";

interface DashboardChipProps {
    text?: string | ReactNode;
    icon?: React.ReactElement;
    backgroundColor?: string;
    borderColor?: string;
    size?: "small" | "medium";
    customStyles?: object;
    onClick?: () => void;
    isDeactivated?: boolean;
}

export const DashboardChip = ({
    text,
    icon,
    backgroundColor,
    borderColor,
    size = "small",
    customStyles,
    onClick,
    isDeactivated = false
}: DashboardChipProps) => {
    return (
        <Chip
            avatar={icon ? React.cloneElement(icon, { color: "inherit" }) : undefined}
            label={
                <Box display="flex" alignItems="center">
                    {text}
                </Box>
            }
            size={size}
            // For some reason the lack of a defined onclick makes the chip invisible when printing
            // using a noop function instead
            onClick={onClick ? onClick : () => { }}
            sx={{
                flex: 1,
                color: isDeactivated ? theme => theme.palette.text.disabled : "#FFFFFF",
                bgcolor: isDeactivated ? theme => theme.palette.action.disabledBackground : backgroundColor,
                borderRadius: "4px",
                border: theme => `1px solid ${isDeactivated ? theme.palette.action.disabled : borderColor || "#000000"}`,
                pointerEvents: onClick ? 'auto' : 'none',
                cursor: onClick ? 'pointer' : 'default',
                transition: onClick ? 'background-color 0.3s, transform 0.3s' : undefined,
                "--main-hover-color": darken(backgroundColor || "#000000", 0.2),
                "&:hover": {
                    backgroundColor: onClick ? "var(--main-hover-color)" : backgroundColor
                },
                "& .MuiChip-avatar": {
                    color: "inherit",
                    background: "none !important",
                },
                position: 'relative',
                ...customStyles
            }}
        />
    );
};